export { default as CartesianCoord } from './cartesian';
export { default as PolarCoord } from './polar';
export var coordType;
(function (coordType) {
    coordType["CARTESIAN2D"] = "cartesian2d";
    coordType["POLAR"] = "polar";
    coordType["GEO"] = "geo";
    coordType["CALENDAR"] = "calendar";
    coordType["AMAP"] = "amap";
})(coordType || (coordType = {}));
